exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "._3yiu-RNNaOkqj1gdHCVdgd {\n  right: 50%;\n  width: 120px;\n  -webkit-backface-visibility: hidden;\n          backface-visibility: hidden;\n  position: absolute;\n}\n\n._12urr0eJ3kPbfOkLPfhOdy {\n  width: 40px;\n  top: 15px;\n  left: 30px;\n}\n\n.WcPWGhNaL8ERe_ruYCKUr {\n  top: 15px;\n  left: 30px;\n}\n\n.UmDD1zLYqzlqd5qUR9O94 {\n  top: -20px;\n  left: 13px;\n  width: 140px;\n}\n\n._1_JzQq6hPqFcVRiKhyUnN {\n  top: 20px;\n  left: 205px;\n}\n\n._3JJfUxfqt0vR7EU-vfbywx {\n  width: 300px;\n  top: -20px;\n  left: 25px;\n}\n\n._1Ykt7GVXNTa49usdgcXiMq {\n  width: 70px;\n  top: 20px;\n  left: 140px;\n}\n\n._15pBeORYh28lyf54hM2y0a {\n  top: 15px;\n  left: 115px;\n}\n\n._3daCpscvKN6dGUsJ3BWfh7 {\n}\n\n._2qXSUV1ZDlsO3UnPoZ7XfV {\n}\n\n._2GYzC_ui5HLKkvUYQGkcX0 {\n  top: 15px;\n  left: 20px;\n}\n", ""]);

// exports
exports.locals = {
	"bankLogo": "_3yiu-RNNaOkqj1gdHCVdgd",
	"bb-ourocard-black": "_12urr0eJ3kPbfOkLPfhOdy _3yiu-RNNaOkqj1gdHCVdgd",
	"bradesco-normal-black": "WcPWGhNaL8ERe_ruYCKUr _3yiu-RNNaOkqj1gdHCVdgd",
	"bradesco-prime-black": "UmDD1zLYqzlqd5qUR9O94 _3yiu-RNNaOkqj1gdHCVdgd",
	"caixa-normal-black": "_1_JzQq6hPqFcVRiKhyUnN _3yiu-RNNaOkqj1gdHCVdgd",
	"itau-normal-black": "_3JJfUxfqt0vR7EU-vfbywx _3yiu-RNNaOkqj1gdHCVdgd",
	"itau-personnalite-black": "_1Ykt7GVXNTa49usdgcXiMq _3yiu-RNNaOkqj1gdHCVdgd",
	"nubank": "_15pBeORYh28lyf54hM2y0a _3yiu-RNNaOkqj1gdHCVdgd",
	"nubank-normal-gold": "_3daCpscvKN6dGUsJ3BWfh7 _15pBeORYh28lyf54hM2y0a _3yiu-RNNaOkqj1gdHCVdgd",
	"nubank-normal-platinum": "_2qXSUV1ZDlsO3UnPoZ7XfV _15pBeORYh28lyf54hM2y0a _3yiu-RNNaOkqj1gdHCVdgd",
	"santander-normal-black": "_2GYzC_ui5HLKkvUYQGkcX0 _3yiu-RNNaOkqj1gdHCVdgd"
};


//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader?{"importLoaders":1,"modules":true}!../node_modules/postcss-loader/lib?{"ident":"postcss"}!../node_modules/postcss-loader/lib?{"plugins":[null]}!./components/BankLogo/style.css
// module id = 30
// module chunks = 0